try {
    let L = 0, l, z = document.documentElement;
    z.addEventListener('keyup', (event) => {
        if (event.keyCode === 67 && -1 === ['INPUT', 'TEXTAREA', 'SELECT'].indexOf(document.activeElement.tagName)) {
            if (++L === 5) {
                l = 'O____O';
                let style = document.createElement('style');
                style.innerHTML = `.${l} {
                    transition: transform 1s cubic-bezier(.5, 0, .5, 1);
                    transform: rotate(360deg);
                }`;
                z.appendChild(style);
                z.className += ` ${l}`;
                window.setTimeout(() => {
                    z.className = z.className.replace(` ${l}`, '');
                }, 1000);
            }
            window.setTimeout(() => L = 0, 1000);
        } else {
            L = 0;
        }
    });
} catch(err) {
    // empty
}



// WEBPACK FOOTER //
// ./config/easter.js